export type PowerStatistic =
  | SensorAggregateStatistic.MIN
  | SensorAggregateStatistic.MAX
  | SensorAggregateStatistic.AVG

export type VoltageStatistic =
  | SensorAggregateStatistic.MIN
  | SensorAggregateStatistic.MAX
  | SensorAggregateStatistic.AVG

export type CurrentStatistic =
  | SensorAggregateStatistic.MIN
  | SensorAggregateStatistic.MAX
  | SensorAggregateStatistic.AVG

export type FrequencyStatistic =
  | SensorAggregateStatistic.MIN
  | SensorAggregateStatistic.MAX
  | SensorAggregateStatistic.AVG

export type PowerFactorStatistic =
  | SensorAggregateStatistic.MIN
  | SensorAggregateStatistic.MAX
  | SensorAggregateStatistic.AVG

export enum SensorAggregateStatistic {
  MIN = 'min',
  MAX = 'max',
  AVG = 'avg'
}

export default SensorAggregateStatistic
